export const FORMULA_QUESTION_TYPES = [
  'text',
  'textarea',
  'range',
  'radiobox',
  'selectbox',
  'select-box-with-filter',
  'check_box',
  'star',
  'category_input'
]

export function visibleFormItems(questions) {
  return (questions || []).filter(item => item && item.visibility !== false)
}

export function parentStepOf(questions, questionId) {
  const list = visibleFormItems(questions)
  const index = list.findIndex(item => String(item.id) === String(questionId))
  if (index < 0) {
    return null
  }
  for (let cursor = index; cursor >= 0; cursor -= 1) {
    if (list[cursor].type === 'step') {
      return list[cursor]
    }
  }
  return null
}

export function stepTitleOf(step) {
  if (!step) {
    return 'شروع'
  }
  return step.title || `مرحله ${step.id}`
}

export function questionVariable(question) {
  if (!question) {
    return ''
  }
  const variable = String(question.variable || '').trim()
  if (variable) {
    return variable
  }
  return String(question.slug || '').trim()
}

export function questionTitle(question) {
  if (!question) {
    return ''
  }
  return question.title || `سؤال ${question.id}`
}

export function questionRefLabel(questions, question, options) {
  if (!question) {
    return ''
  }
  const withStep = !options || options.withStep !== false
  const step = parentStepOf(questions, question.id)
  const variable = questionVariable(question)
  const name = variable || questionTitle(question)
  if (!withStep) {
    return name
  }
  return `${name} · ${stepTitleOf(step)}`
}

export function formulaToken(question) {
  return `{{q:${question.id}}}`
}

export function groupQuestionsByStep(questions, items) {
  const groups = []
  const index = {}
  ;(items || []).forEach(question => {
    if (!question || question.type === 'step') {
      return
    }
    const step = parentStepOf(questions, question.id)
    const key = step ? String(step.id) : 'start'
    if (!index[key]) {
      index[key] = {
        key,
        stepId: step ? step.id : '',
        title: stepTitleOf(step),
        questions: []
      }
      groups.push(index[key])
    }
    index[key].questions.push(question)
  })
  return groups
}

export function bindConditionQuestion(questions, condition, questionId) {
  const question = (questions || []).find(item => String(item.id) === String(questionId))
  const step = parentStepOf(questions, questionId)
  condition.question_id = questionId
  condition.step_id = step ? step.id : ''
  condition.variable = question ? questionVariable(question) : ''
  return condition
}

export function humanizeFormula(formula, questions) {
  return String(formula || '').replace(/\{\{q:([^}]+)\}\}/g, (match, id) => {
    const question = (questions || []).find(item => String(item.id) === String(id).trim())
    if (!question) {
      return match
    }
    return `[${questionRefLabel(questions, question)}]`
  })
}

export function ensurePriceConfig(formQuestionsRoot) {
  if (!formQuestionsRoot || typeof formQuestionsRoot !== 'object') {
    return {enabled: false, default_formula: '', value_source: 'option_price', rules: []}
  }
  if (!formQuestionsRoot.price || typeof formQuestionsRoot.price !== 'object') {
    formQuestionsRoot.price = {enabled: false, default_formula: '', value_source: 'option_price', rules: []}
  }
  if (typeof formQuestionsRoot.price.enabled === 'undefined') {
    formQuestionsRoot.price.enabled = false
  }
  if (typeof formQuestionsRoot.price.default_formula === 'undefined') {
    formQuestionsRoot.price.default_formula = ''
  }
  if (!formQuestionsRoot.price.value_source) {
    formQuestionsRoot.price.value_source = 'option_price'
  }
  if (!Array.isArray(formQuestionsRoot.price.rules)) {
    formQuestionsRoot.price.rules = []
  }
  return formQuestionsRoot.price
}

export function suggestBasePremium(label) {
  const text = String(label || '')
  if (/پیکان|پراید|سپند/i.test(text)) {
    return 89440000
  }
  if (/سه سیلندر|۳ سیلندر|3 سیلندر|کمتر از ۴|کمتر از 4/i.test(text)) {
    return 75522000
  }
  if (/بیش از ۴|بیش از 4|بیشتر از ۴|بیشتر از 4/i.test(text)) {
    return 117665000
  }
  if (/0\.5|۰\.۵|نیم تن|تا ۱ تن|تا 1 تن|تا یک تن/i.test(text)) {
    return 92533000
  }
  if (/۱ تا ۳|1 تا 3|1 to 3/i.test(text)) {
    return 111415000
  }
  if (/گازی|موتور.*گاز/i.test(text)) {
    return 18750000
  }
  if (/یک سیلندر|1 سیلندر|۱ سیلندر/i.test(text) && /موتور/.test(text)) {
    return 22907000
  }
  if (/کشاورز/i.test(text)) {
    return 31306000
  }
  if (/پژو|سمند|دنا|سایر ۴|ساير ۴|۴ سیلندر|4 سیلندر/i.test(text)) {
    return 105132000
  }
  if (/وانت|بارکش|نیسان/i.test(text)) {
    return 92533000
  }
  return ''
}

export function applySuggestedOptionPrices(questions) {
  visibleFormItems(questions).forEach(question => {
    if (!Array.isArray(question.options)) {
      return
    }
    question.options.forEach(option => {
      if (option.price !== '' && option.price !== null && typeof option.price !== 'undefined') {
        return
      }
      const suggested = suggestBasePremium(option.label)
      if (suggested !== '') {
        option.price = suggested
      }
    })
  })
}

export function findQuestionByVariableOrTitle(questions, names) {
  const list = visibleFormItems(questions).filter(item => item.type !== 'step')
  const normalized = names.map(name => String(name).trim())
  return list.find(question => {
    const variable = questionVariable(question)
    const title = questionTitle(question)
    return normalized.indexOf(variable) !== -1 || normalized.indexOf(title) !== -1
  }) || null
}

export function optionIdByLabel(question, matcher) {
  if (!question || !Array.isArray(question.options)) {
    return ''
  }
  const option = question.options.find(item => matcher.test(String(item.label || '')))
  return option ? option.id : ''
}

export function buildThirdPartyPriceRules(questions) {
  const vehicleType = findQuestionByVariableOrTitle(questions, ['نوع ماشین', 'نوع وسیله نقلیه'])
  const passenger = findQuestionByVariableOrTitle(questions, ['سوال 12'])
    || visibleFormItems(questions).find(item => {
      const step = parentStepOf(questions, item.id)
      return item.type === 'selectbox' && step && /سواری/.test(step.title || '')
    })
  const cargo = findQuestionByVariableOrTitle(questions, ['سوال 14'])
    || visibleFormItems(questions).find(item => {
      const step = parentStepOf(questions, item.id)
      return item.type === 'selectbox' && step && /سنگین|بارکش/.test(step.title || '')
    })
  const taxiId = optionIdByLabel(vehicleType, /تاکسی/)
  const personalId = optionIdByLabel(vehicleType, /شخصی|سواری/)
  const heavyId = optionIdByLabel(vehicleType, /سنگین/)
  const rules = []
  if (vehicleType && passenger && taxiId !== '') {
    rules.push({
      id: `price_taxi_${Date.now()}`,
      title: 'تاکسی شهری — ۱۰٪ افزایش',
      formula: `${formulaToken(passenger)} * 1.1`,
      when: {all: [{
        question_id: vehicleType.id,
        step_id: parentStepOf(questions, vehicleType.id) ? parentStepOf(questions, vehicleType.id).id : '',
        variable: questionVariable(vehicleType),
        op: 'eq',
        value: taxiId
      }]}
    })
  }
  if (vehicleType && passenger && personalId !== '') {
    rules.push({
      id: `price_personal_${Date.now() + 1}`,
      title: 'سواری شخصی',
      formula: formulaToken(passenger),
      when: {all: [{
        question_id: vehicleType.id,
        step_id: parentStepOf(questions, vehicleType.id) ? parentStepOf(questions, vehicleType.id).id : '',
        variable: questionVariable(vehicleType),
        op: 'eq',
        value: personalId
      }]}
    })
  }
  if (vehicleType && cargo && heavyId !== '') {
    rules.push({
      id: `price_cargo_${Date.now() + 2}`,
      title: 'وسیله سنگین / بارکش',
      formula: formulaToken(cargo),
      when: {all: [{
        question_id: vehicleType.id,
        step_id: parentStepOf(questions, vehicleType.id) ? parentStepOf(questions, vehicleType.id).id : '',
        variable: questionVariable(vehicleType),
        op: 'eq',
        value: heavyId
      }]}
    })
  }
  return {
    default_formula: passenger ? formulaToken(passenger) : '',
    rules
  }
}
